/* unplugin-vue-components disabled */import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/dark.svg';
import _imports_1 from '@/assets/images/light.svg';
const _hoisted_1 = {
  class: "setting-drawer-block-checbox"
};
const _hoisted_2 = {
  key: 0,
  class: "setting-drawer-block-checbox-selectIcon",
  style: {
    "display": "block"
  }
};
const _hoisted_3 = {
  "aria-label": "图标: check",
  class: "anticon anticon-check"
};
const _hoisted_4 = ["fill"];
const _hoisted_5 = {
  key: 0,
  class: "setting-drawer-block-checbox-selectIcon",
  style: {
    "display": "block"
  }
};
const _hoisted_6 = {
  "aria-label": "图标: check",
  class: "anticon anticon-check"
};
const _hoisted_7 = ["fill"];
const _hoisted_8 = {
  class: "drawer-item"
};
const _hoisted_9 = {
  class: "comp-style"
};
const _hoisted_10 = {
  class: "drawer-item"
};
const _hoisted_11 = {
  class: "comp-style"
};
const _hoisted_12 = {
  class: "drawer-item"
};
const _hoisted_13 = {
  class: "comp-style"
};
const _hoisted_14 = {
  class: "drawer-item"
};
const _hoisted_15 = {
  class: "comp-style"
};
const _hoisted_16 = {
  class: "drawer-item"
};
const _hoisted_17 = {
  class: "comp-style"
};
import variables from '@/assets/styles/variables.module.scss';
import originElementPlus from 'element-plus/theme-chalk/index.css';
import axios from 'axios';
import { ElLoading, ElMessage } from 'element-plus';
import { useDynamicTitle } from '@/utils/dynamicTitle';
import useAppStore from '@/store/modules/app';
import useSettingsStore from '@/store/modules/settings';
import usePermissionStore from '@/store/modules/permission';
export default {
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const appStore = useAppStore();
    const settingsStore = useSettingsStore();
    const permissionStore = usePermissionStore();
    const showSettings = ref(false);
    const theme = ref(settingsStore.theme);
    const sideTheme = ref(settingsStore.sideTheme);
    const storeSettings = computed(() => settingsStore);
    const predefineColors = ref(["#409EFF", "#ff4500", "#ff8c00", "#ffd700", "#90ee90", "#00ced1", "#1e90ff", "#c71585"]);

    /** 是否需要topnav */
    const topNav = computed({
      get: () => storeSettings.value.topNav,
      set: val => {
        settingsStore.changeSetting({
          key: 'topNav',
          value: val
        });
        if (!val) {
          appStore.toggleSideBarHide(false);
          permissionStore.setSidebarRouters(permissionStore.defaultRoutes);
        }
      }
    });
    /**是否需要固定头部 */
    const fixedHeader = computed({
      get: () => storeSettings.value.fixedHeader,
      set: val => {
        settingsStore.changeSetting({
          key: 'fixedHeader',
          value: val
        });
      }
    });
    /**是否需要侧边栏的logo */
    const sidebarLogo = computed({
      get: () => storeSettings.value.sidebarLogo,
      set: val => {
        settingsStore.changeSetting({
          key: 'sidebarLogo',
          value: val
        });
      }
    });
    /**是否需要侧边栏的动态网页的title */
    const dynamicTitle = computed({
      get: () => storeSettings.value.dynamicTitle,
      set: val => {
        settingsStore.changeSetting({
          key: 'dynamicTitle',
          value: val
        });
        // 动态设置网页标题
        useDynamicTitle();
      }
    });
    function themeChange(val) {
      settingsStore.changeSetting({
        key: 'theme',
        value: val
      });
      theme.value = val;
    }
    function handleTheme(val) {
      settingsStore.changeSetting({
        key: 'sideTheme',
        value: val
      });
      sideTheme.value = val;
    }
    function saveSetting() {
      proxy.$modal.loading("正在保存到本地，请稍候...");
      let layoutSetting = {
        "topNav": storeSettings.value.topNav,
        "fixedHeader": storeSettings.value.fixedHeader,
        "sidebarLogo": storeSettings.value.sidebarLogo,
        "dynamicTitle": storeSettings.value.dynamicTitle,
        "sideTheme": storeSettings.value.sideTheme,
        "theme": storeSettings.value.theme
      };
      localStorage.setItem("layout-setting", JSON.stringify(layoutSetting));
      setTimeout(proxy.$modal.closeLoading(), 1000);
    }
    function resetSetting() {
      proxy.$modal.loading("正在清除设置缓存并刷新，请稍候...");
      localStorage.removeItem("layout-setting");
      setTimeout("window.location.reload()", 1000);
    }
    function openSetting() {
      showSettings.value = true;
    }
    __expose({
      openSetting
    });
    return (_ctx, _cache) => {
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createBlock(_component_el_drawer, {
        modelValue: _unref(showSettings),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(showSettings) ? showSettings.value = $event : null),
        withHeader: false,
        direction: "rtl",
        size: "30rem"
      }, {
        default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "setting-drawer-title"
        }, [_createElementVNode("h3", {
          class: "drawer-title"
        }, "主题风格设置")], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: "setting-drawer-block-checbox-item",
          onClick: _cache[0] || (_cache[0] = $event => handleTheme('theme-dark'))
        }, [_cache[9] || (_cache[9] = _createElementVNode("img", {
          src: _imports_0,
          alt: "dark"
        }, null, -1)), _unref(sideTheme) === 'theme-dark' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("i", _hoisted_3, [(_openBlock(), _createElementBlock("svg", {
          viewBox: "64 64 896 896",
          "data-icon": "check",
          width: "1em",
          height: "1em",
          fill: _unref(theme),
          "aria-hidden": "true",
          focusable: "false",
          class: ""
        }, [...(_cache[8] || (_cache[8] = [_createElementVNode("path", {
          d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
        }, null, -1)]))], 8, _hoisted_4))])])) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: "setting-drawer-block-checbox-item",
          onClick: _cache[1] || (_cache[1] = $event => handleTheme('theme-light'))
        }, [_cache[11] || (_cache[11] = _createElementVNode("img", {
          src: _imports_1,
          alt: "light"
        }, null, -1)), _unref(sideTheme) === 'theme-light' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("i", _hoisted_6, [(_openBlock(), _createElementBlock("svg", {
          viewBox: "64 64 896 896",
          "data-icon": "check",
          width: "1em",
          height: "1em",
          fill: _unref(theme),
          "aria-hidden": "true",
          focusable: "false",
          class: ""
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("path", {
          d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
        }, null, -1)]))], 8, _hoisted_7))])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_8, [_cache[12] || (_cache[12] = _createElementVNode("span", null, "主题颜色", -1)), _createElementVNode("span", _hoisted_9, [_createVNode(_component_el_color_picker, {
          modelValue: _unref(theme),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(theme) ? theme.value = $event : null),
          predefine: _unref(predefineColors),
          onChange: themeChange
        }, null, 8, ["modelValue", "predefine"])])]), _createVNode(_component_el_divider), _cache[20] || (_cache[20] = _createElementVNode("h3", {
          class: "drawer-title"
        }, "系统布局配置", -1)), _createElementVNode("div", _hoisted_10, [_cache[13] || (_cache[13] = _createElementVNode("span", null, "开启 TopNav", -1)), _createElementVNode("span", _hoisted_11, [_createVNode(_component_el_switch, {
          modelValue: _unref(topNav),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(topNav) ? topNav.value = $event : null),
          class: "drawer-switch"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_12, [_cache[14] || (_cache[14] = _createElementVNode("span", null, "固定 Header", -1)), _createElementVNode("span", _hoisted_13, [_createVNode(_component_el_switch, {
          modelValue: _unref(fixedHeader),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(fixedHeader) ? fixedHeader.value = $event : null),
          class: "drawer-switch"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_14, [_cache[15] || (_cache[15] = _createElementVNode("span", null, "显示 Logo", -1)), _createElementVNode("span", _hoisted_15, [_createVNode(_component_el_switch, {
          modelValue: _unref(sidebarLogo),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(sidebarLogo) ? sidebarLogo.value = $event : null),
          class: "drawer-switch"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_16, [_cache[16] || (_cache[16] = _createElementVNode("span", null, "动态标题", -1)), _createElementVNode("span", _hoisted_17, [_createVNode(_component_el_switch, {
          modelValue: _unref(dynamicTitle),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(dynamicTitle) ? dynamicTitle.value = $event : null),
          class: "drawer-switch"
        }, null, 8, ["modelValue"])])]), _createVNode(_component_el_divider), _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: "DocumentAdd",
          onClick: saveSetting
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("保存配置", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          plain: "",
          icon: "Refresh",
          onClick: resetSetting
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("重置配置", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};